var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 41,
    viewBox: "0 0 49 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8625 10.96C34.2405 4.658 28.0725 0.5 21.1665 0.5C11.7925 0.5 4.1665 8.126 4.1665 17.5C4.1665 18.602 4.2725 19.694 4.4805 20.766C1.7865 22.83 0.166504 26.058 0.166504 29.5C0.166504 35.564 4.6525 40.5 10.1665 40.5H33.1665C41.4385 40.5 48.1665 33.772 48.1665 25.5C48.1665 18.566 43.4785 12.628 36.8625 10.96ZM30.7525 25.084L26.1665 20.498V32.498H22.1665V20.498L17.5805 25.084L14.7525 22.256L21.3385 15.67C22.8965 14.112 25.4365 14.112 26.9945 15.67L33.5805 22.256L30.7525 25.084Z",
    fill: "#14232A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0813bfafd700161e3faab8973b4d28a0.svg";
export { ForwardRef as ReactComponent };